import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Typography, notification, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import Icon, {
} from '@ant-design/icons';
import { FaDownload } from 'react-icons/fa';
import moment from 'moment';

import { validacaoPermissao, VerificaRota } from './../../../../services/VerificaSePodeAcessar';
import { EmitError } from '../../../../utils/EmitError';

import { convertDataUSParaBrasilEHora } from './../../../../utils/Conversores';

import { useGetColumnSearchProps } from './../../../../hooks/FilterTable/stringCLearFiltros';
import { useGetColumnSearchPropsData } from './../../../../hooks/FilterTable/date';

import { RcFile } from 'antd/lib/upload';
import { UploadChangeParam } from 'antd/es/upload/interface';
import { UploadFile } from 'antd/lib/upload/interface';
import { useGetColumnSearchPropsObj } from '../../../../hooks/FilterTable/objString';
import RecibosImportarService from '../../../../services/http/services/Recibos/RecibosImportarService';

const { Text } = Typography;

const IconDownload = (props: any) => <Icon {...props} component={FaDownload} ></Icon>

interface IUsuario {
    id: number;
    nome: string;
}

interface IReceipt {
    uuid: string;
    createdAt: string;
    updatedAt: string;
    id: number;
    id_recibo: string;
    siafi: string;
    cod_ibge: string;
    municipio: string;
    ano: string;
    mes: string;
    valor: string;
    extenso: string;
    userId: number;
    importId: number;
}

interface IDadosTable {
    id: number;
    nomeArquivo: string;
    tipo: string;
    userId: number;
    entityId: number;
    usuario: IUsuario;
    receipt: IReceipt[];
    created_at: string;
    updated_at: string;
}

interface DadosCidadesAll {
    "idIbge": number,
    "nome": string,
}

export default function useImportar() {

    const navigate = useNavigate();

    const refController = useRef(new AbortController());
    const refFuncaoLimparFiltrosString = useRef<any>(null);

    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const refDataListCidades = useRef<Array<DadosCidadesAll>>([]);

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<IDadosTable>>([]);
    const [visibleModal, setVisibleModal] = useState<boolean>(false);

    const [arquivoObjeto, setArquivoObjeto] = useState<any>(null);

    const [dataEntity, setdataEntity] = useState(
        JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null
    );

    const [activeKeyTabs, setActiveKeyTabs] = useState<any>('1dadosDosMunicipios');
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);

    //setando dados das cidades no selected
    const buscaRecibos = useCallback(() => {

        const requestAsync = async () => {
            try {
                setLoadingPage(true);

                let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

                const data = await RecibosImportarService.getRecibos(LSEntidade.entity.id, refController.current.signal);

                refDataListCidades.current = data
                setDadosTabelaState(data);

                setLoadingPage(false);

            } catch (error) {

                setLoadingPage(false);

                EmitError(error, true, 'municipios_dkwdfaiweyi')


            }
        }

        requestAsync();

    }, []);

    useEffect(() => {

        refController.current = new AbortController();

        // let arrayUrl = window.location.pathname.split("/");
        // VerificaRota(arrayUrl, navigate, true, validacaoPermissao(['import_files']));

        buscaRecibos();

    }, []);

    const beforeUpload = useCallback((file: RcFile) => {
        const isJson = file.type === 'application/json' || file.name.toLowerCase().endsWith('.json');;

        if (!isJson) {
            message.error('Você só pode fazer upload de arquivos no formato JSON!');
        }

        return isJson;
    }, []);


    const handleChange = useCallback((info: UploadChangeParam<UploadFile<any>>) => {

        if (info?.file?.status === 'done') {
            setArquivoObjeto(info)
        }


    }, [arquivoObjeto]);

    const clickBtnBaixarXLSX = useCallback((arquivo?: string, nomeArquivo?: IDadosTable) => {

        const buscaXLSX = async () => {
            try {

                if (nomeArquivo && nomeArquivo.receipt.length > 0) {
                    const jsonString = JSON.stringify(nomeArquivo.receipt, null, 2);
                    const blob = new Blob([jsonString], { type: "application/json" });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = `${nomeArquivo.nomeArquivo}.${nomeArquivo.tipo}`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    notification.error({
                        message: 'Atenção',
                        description: 'Arquivo não contem recibos para serem baixados.',
                    });
                }

            } catch (error) {

                EmitError(error, true, 'relatorioconsolidado_dkwdfaiweyi')

            }
        }

        buscaXLSX();

    }, []);

    const clickCancelModal = useCallback(() => {
        setArquivoObjeto(null);
        setVisibleModal(false);
    }, []);

    const dummyRequest = useCallback(({ file, onSuccess }: any) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    }, []);

    const clickBtnSubmitUploadArquivo = useCallback((arquivo: any) => {

        const buscaXLSX = async () => {

            setLoading(true)
            const reader = new FileReader();
            reader.readAsText(arquivo.file.originFileObj);

            reader.onload = async () => {
                try {
                    const jsonData = JSON.parse(reader.result as string);

                    if (!jsonData?.length || jsonData?.length === 0) {
                        notification.error({
                            message: 'Atenção',
                            description: 'Arquivo não contem recibos.',
                        });
                        return
                    }

                    let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

                    const dataAtual = new Date().toISOString().split('T')[0];
                    const nomeOriginal = arquivo.file.name.replace(/\.[^/.]+$/, "");
                    const nomeArquivoOriginal = arquivo.file.originFileObj.name;
                    const extensaoArquivo = nomeArquivoOriginal.split('.').pop();
                    const nomeArquivo = `${dataAtual}_${nomeOriginal}`;

                    const jsonDataTransformado = jsonData.map((item: any) => ({
                        ...item,
                        id_recibo: item.id,
                        id: undefined
                    }));

                    let objSalvar = {
                        nomeArquivo: nomeArquivo,
                        tipo: extensaoArquivo,
                        entityId: LSEntidade.entity.id,
                        receipt: jsonDataTransformado
                    };


                    await RecibosImportarService.postRecibosJson(objSalvar, refController.current.signal)

                    notification.success({
                        message: 'Sucesso',
                        description: "Arquivo enviado com sucesso!",
                    });

                    clickCancelModal();
                    buscaRecibos();

                } catch (error) {
                    setLoading(false)

                    EmitError(error, true, 'relatorioconsolidado_dkwdfaiweyi')
                }
            };

            reader.onerror = () => {
                message.error("Erro ao ler o arquivo.");
            };

            setLoading(false)

        }


        buscaXLSX();

    }, []);



    const columns = [
        {
            title: 'Nome Arquivo',
            dataIndex: 'nomeArquivo',
            ...useGetColumnSearchProps('nomeArquivo', refFuncaoLimparFiltrosString),
            width: '10%',
            sorter: (a: any, b: any) => a?.nomeArquivo?.localeCompare(b?.nomeArquivo),
            showSorterTooltip: false,
        },
        {
            title: 'Tipo de Arquivo',
            dataIndex: 'tipo',
            ...useGetColumnSearchProps('tipo', refFuncaoLimparFiltrosString),
            width: '8%',
            sorter: (a: any, b: any) => a?.tipo?.localeCompare(b?.tipo),
            showSorterTooltip: false,
            render: (tipo: any) => {

                return tipo
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            ...useGetColumnSearchPropsObj('usuario'),
            width: '10%',
            sorter: (a: any, b: any) => a?.usuario?.nome.localeCompare(b?.usuario?.nome),
            showSorterTooltip: false,
            render: (usuario: any) => {

                return usuario?.nome
            },
        },
        // {
        //     title: 'Validade',
        //     dataIndex: 'dataValidade',
        //     ...useGetColumnSearchPropsData('dataValidade'),
        //     width: '2%',
        //     sorter: (a: any, b: any) => {

        //         let aMonMen: any = null
        //         let bMonMen: any = null
        //         if (a.dataValidade) {
        //             aMonMen = moment(a.dataValidade).unix()
        //         } else {
        //             aMonMen = 0
        //         }
        //         if (b.dataValidade) {
        //             bMonMen = moment(b.dataValidade).unix()
        //         } else {
        //             bMonMen = 0
        //         }

        //         return aMonMen - bMonMen
        //     },
        //     showSorterTooltip: false,
        //     // sorter: (a: any, b: any) => a.dataValidade.localeCompare(b.dataValidade),
        //     render: (criado: any, record: any) => {
        //         return (
        //             <div
        //                 style={{
        //                     display: 'flex',
        //                     justifyContent: 'space-between',
        //                     alignItems: 'center'
        //                 }}
        //             >

        //                 <Text>
        //                     {
        //                         criado ? convertDataUSParaBrasil(criado) : '-'
        //                     }
        //                 </Text>

        //                 {/* <img style={{
        //                     width: 20,
        //                     marginLeft: 5
        //                 }} src={record.status ? ImgDownLike : ImgUpLike} /> */}
        //             </div>
        //         )
        //     },
        // },
        {
            title: 'Criado em',
            dataIndex: 'created_at',
            ...useGetColumnSearchPropsData('created_at'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.created_at) {
                    aMonMen = moment(a?.created_at)?.unix()
                } else {
                    aMonMen = 0
                }
                if (b.created_at) {
                    bMonMen = moment(b?.created_at)?.unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (data: any) => {

                return (
                    convertDataUSParaBrasilEHora(data)
                )
            },
        },
        {
            title: '',
            dataIndex: 'nomeArquivo',
            width: '2%',
            showSorterTooltip: false,
            render: (nomeArquivo: string, record: IDadosTable) => {
                return (
                    <div className='naoElinha'>
                        {
                            nomeArquivo ?
                                <Button
                                    type="primary"
                                    className="botaoNaolinha"
                                    onClick={() => { clickBtnBaixarXLSX(nomeArquivo, record) }}
                                >
                                    {'Baixar '}<IconDownload />
                                </Button>
                                :
                                <Text
                                    style={{
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {'Não há arquivo.'}
                                </Text>
                        }

                    </div>
                )
            },
        },
    ];


    return {
        loadingPage,
        setVisibleModal,
        columns,
        dadosTabelaState,
        refContagemDoFiltro,
        visibleModal,
        clickBtnSubmitUploadArquivo,
        arquivoObjeto,
        clickCancelModal,
        loading,
        activeKeyTabs,
        setActiveKeyTabs,
        dummyRequest,
        beforeUpload,
        handleChange,
        setArquivoObjeto,
    }
}
